import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import AppRoute from "./routes/AppRoute";
import "../src/assets/css/navbar.css";
import { initGA } from "../src/helper/analytics";
import "../src/locales/index.js";

initGA();
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found! Check your public/index.html file.");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AppRoute />
  </React.StrictMode>
);

reportWebVitals();
